import React from 'react';
import cn from 'classnames';
import styles from './ErrorMessage.module.scss';

const ErrorMessage = ({ children, className }) => (
  <div className={cn(styles.errorMessage, className)}>{children}</div>
);

export default ErrorMessage;
